import React from 'react';

import { Icon } from 'DesignLibrary/atoms';

import { StackedIconContainer } from './styled';

export interface StackedIconProps {
  circleArgs: { color: string; size: 'large' | 'small' | 'normal'; weight?: 'fill' | 'regular' };
  stackedIcon: React.ReactNode;
  dataTestId?: string;
}

export const StackedIcon = ({ circleArgs, stackedIcon, dataTestId = 'stacked-icon' }: StackedIconProps) => {
  return (
    <StackedIconContainer data-testid={dataTestId}>
      <Icon type="Circle" size={circleArgs.size} color={circleArgs.color} weight={circleArgs.weight} />
      {stackedIcon}
    </StackedIconContainer>
  );
};
